<template>
    <div>
        <div :class="{ 'numeric-card': true, '--dark': isDarkTheme }">
            <div class="numeric-card__title" :style="{ backgroundColor: titleData.title_background_color }">
                <h2 :style="{ color: titleData.title_text_color }">
                    {{ titleData.title }}
                </h2>
            </div>

            <div class="numeric-card__overflow">
                <div class="numeric-card__overflow__flex">
                    <div
                        class="numeric-card__overflow__flex__group"
                        :style="{ backgroundColor: card.background_color }"
                        v-for="(card, idx) in data.numeric_block_items"
                        :key="card.id"
                        :title="card.text"
                    >
                        <div class="numeric-card__overflow__flex__group__number">
                            <span :style="{ color: data.title_text_color }">{{ idx + 1 }}</span>
                            <hr :style="{ backgroundColor: data.title_background_color }" />
                        </div>

                        <div :style="{ color: card.text_color }" v-html="card.text" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueTypes from 'vue-types';
import { NumericBlock, TitleSettings } from '../../types';

export default {
    name: 'NumberList',
    props: {
        data: NumericBlock,
        titleData: TitleSettings,
        isDarkTheme: VueTypes.bool.def(false)
    }
};
</script>

<style lang="scss" scoped>
@import '~/themes/novaporta/assets/styles/utils';
@import './styles.scss';
</style>
